// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bbe4219ade519ec5916d8acdc177ddb8828642ff.chunk.js";
};